<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" (onRowSelect)="onRowSelect($event)" [(selection)]="selectedMasterList">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field != 'active'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" class="h-2rem" pButton icon="pi pi-plus" (click)="showDialogToAddResultConfig()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="Result Configuration" position="top" [(visible)]="showDialogToAddOrUpdateResult" [focusOnShow]="false"
  [modal]="true" [style]="{'width':'850px'}"   [baseZIndex]="10000" [contentStyle]="{'overflow':'visible', 'overflow-y':'scroll'}" maximizable="true">
  <p-confirmDialog></p-confirmDialog>
  <p-toast sticky="true"></p-toast>
  <div class="col-12 flex p-0 ">
    <div class="col-6 p-0 text-right">
      <label class="mr-2 topText">Kit Name :</label>
    </div>
    <div class="col-6 p-0 text-left">
      <p-dropdown [options]="kits" [(ngModel)]="resultConfig.kitName" placeholder="Select a Kit Name" (onChange)="changeSelectedKit($event)" [style]="{'width':'55%'}" 
        [disabled]="this.resultConfig?.isChannelRemoved"></p-dropdown>
    </div>
  </div>
  <div class="col-12 flex p-0 pt-2 text-center">
    <div class="col-6 p-0 text-right">
      <label class="mr-2 topText">Cycle Type :</label>
    </div>
    <div class="col-6 p-0 text-left">
      <p-dropdown [options]="cyclers" [(ngModel)]="resultConfig.cycler" placeholder="Select a Cycler Name" [style]="{'width':'55%'}"
        [disabled]="this.resultConfig?.isChannelRemoved"></p-dropdown>
    </div>
  </div>
  <div class="col-12 flex p-0 pt-2 text-center">
    <div class="col-6 p-0 text-right">
      <label class="mr-2 topText">Result Name :</label>
    </div>
    <div class="col-6 p-0 text-left">
      <input class="resultNameText" pInputText placeholder="Enter Result Logic Name" [(ngModel)]="resultConfig.resultName"
        [disabled]="this.resultConfig?.isChannelRemoved"/>
    </div>
  </div>
  <div *ngIf="verifiedResult && !newResult" class="col-12 flex p-0 pt-2 text-center">
    <button pButton [disabled]="!isCloneEnabled()" label="Clone"icon="fa fa-clone" (click)="cloneExistingResultConfig()"></button>
  </div>
  <div class="mainBody">
    <div *ngIf="verifiedResult" class="col-12 flex p-0 pt-2">
      <div class="col-12 flex border border-info">
        <div class="col-12 flex p-0 text-center font-weight-bold">
          <label>Channel Cut Offs</label>
        </div>
        <div class="col-12 flex p-0">
          <table class="table" aria-describedby="table to add channels">
            <th *ngIf="false" scope="col"></th>
            <tbody>
              <tr>
                <td>Channel</td>
                <td>
                  <p-dropdown [options]="firstChannelList" [(ngModel)]="resultChannels[0].channelName" 
                    placeholder="Select Channel" (onChange)="calibrateOptions(0)" [disabled]="this.resultConfig?.isChannelRemoved"></p-dropdown>
                </td>
                <td>
                  <p-dropdown [options]="secondChannelList" [(ngModel)]="resultChannels[1].channelName" 
                    placeholder="Select Channel" (onChange)="calibrateOptions(1)" [disabled]="this.resultConfig?.isChannelRemoved"></p-dropdown>
                </td>
                <td>
                  <p-dropdown  [options]="thirdChannelList" [(ngModel)]="resultChannels[2].channelName" 
                    placeholder="Select Channel" (onChange)="calibrateOptions(2)" [disabled]="this.resultConfig?.isChannelRemoved"></p-dropdown>
                </td>
              </tr>
              <tr>
                <td>Cut-off low</td>
                <td>
                  <p-inputNumber [size]="14" [showButtons]="true" [disabled]="isCutOffColumnedDisabled(0) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[0].lowCp" 
                    [min]="0" [step]="0.1"></p-inputNumber>
                </td>
                <td>
                  <p-inputNumber [size]="14"  [showButtons]="true" [disabled]="isCutOffColumnedDisabled(1) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[1].lowCp" 
                    [min]="0" [step]="0.1"></p-inputNumber>
                </td>
                <td>
                  <p-inputNumber [size]="14" [showButtons]="true" [disabled]="isCutOffColumnedDisabled(2) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[2].lowCp" [min]="0" 
                    [step]="0.1"></p-inputNumber>
                </td>
              </tr>
              <tr>
                <td class="pb-0">Cut-off high</td>
                <td class="pb-0">
                  <p-inputNumber [size]="14" [showButtons]="true" [disabled]="isCutOffColumnedDisabled(0) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[0].highCp" 
                    [min]="0" [step]="0.1"></p-inputNumber>
                </td>
                <td class="pb-0">
                  <p-inputNumber [size]="14" [showButtons]="true" [disabled]="isCutOffColumnedDisabled(1) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[1].highCp" 
                    [min]="0" [step]="0.1"></p-inputNumber>
                </td>
                <td class="pb-0">
                  <p-inputNumber [size]="14" [showButtons]="true" [disabled]="isCutOffColumnedDisabled(2) || this.resultConfig?.isChannelRemoved" [(ngModel)]="resultChannels[2].highCp" 
                    [min]="0" [step]="0.1"></p-inputNumber>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-12 flex mt-1 border border-info createRules">
        <div class="col-12 flex p-0 text-center font-weight-bold">
          <label>Create Rules</label>
        </div>
        <div class="col-12 flex p-0">
          <table class="table" aria-describedby="table to add channels">
            <th *ngIf="false" scope="col"></th>
            <tr>
              <td class="pb-0">
                <label *ngIf="isChannelConfigurable(0)">{{resultChannels[0].channelName}}</label>
              </td>
              <td class="pb-0">
                <label *ngIf="isChannelConfigurable(1)">{{resultChannels[1].channelName}}</label>
              </td>
              <td class="pb-0">
                <label *ngIf="isChannelConfigurable(2)">{{resultChannels[2].channelName}}</label>
              </td>
              <td class="pb-0">
                <label>Result</label>
              </td>
              <td class="pb-0"></td>
            </tr>
            <tr>
              <td class="pb-0">
                <p-dropdown [disabled]="this.resultConfig?.isChannelRemoved" *ngIf="isChannelConfigurable(0)" [options]="channnelValueOptions" 
                  [(ngModel)]="ruleSet.channelValues[0]"></p-dropdown>
              </td>
              <td class="pb-0">
                <p-dropdown [disabled]="this.resultConfig?.isChannelRemoved" *ngIf="isChannelConfigurable(1)" [options]="channnelValueOptions" 
                  [(ngModel)]="ruleSet.channelValues[1]"></p-dropdown>
              </td>
              <td class="pb-0">
                <p-dropdown [disabled]="this.resultConfig?.isChannelRemoved" *ngIf="isChannelConfigurable(2)" [options]="channnelValueOptions" 
                  [(ngModel)]="ruleSet.channelValues[2]"></p-dropdown>
              </td>
              <td class="pb-0">
                <p-dropdown [disabled]="activeIndexs.length == 0 || this.resultConfig?.isChannelRemoved" [options]="ruleResultOptions" 
                  [(ngModel)]="ruleSet.channelResult"></p-dropdown>
              </td>
              <td class="pb-0">
                <button pButton [disabled]="activeIndexs.length == 0 || this.resultConfig?.isChannelRemoved" icon="fa fa-plus" 
                  class="addRule" (click)="decideOnAddRuleSet()"></button>
              </td>
            </tr>
          </table>
          <div class="col-12 flex p-1 text-center">
            <label *ngIf="showErrorMessage" class="text-danger">{{ruleError}}</label>
          </div>
        </div>
        <div *ngIf="ruleSetTableVisible()" class="col-12 flex p-0 pt-2">
          <p-table [columns]="ruleTableHeaders" [value]="ruleSetTable" (sortFunction)="customSort($event)" [customSort]="true">
            <ng-template pTemplate="caption">
              Defined Rules
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" class="text-center" *ngFor="let col of ruleTableHeaders" [pSortableColumn]="col">
                  {{col}}
                  <p-sortIcon [field]="col"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ruleSet>
              <tr>
                <td class="text-center" *ngFor="let i of activeIndexs">
                  {{mapOfChannelValue.get(ruleSet.channelValues[i])}}
                </td>
                <td class="text-center">
                  {{mapOfResultValue.get(ruleSet.channelResult)}}
                </td>
                <td class="text-center">
                  <button class="removeRule" pButton icon="fa fa-trash" (click)="onRowRemove(ruleSet)" [disabled]="this.resultConfig?.isChannelRemoved"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-12 flex p-0 pt-1">
        <p-checkbox [(ngModel)]="resultConfig.active" [binary]="true" label="Active"></p-checkbox>
      </div>
    </div>
    <div class="col-12 flex p-0 pr-2 text-right flex flex justify-content-end">
      <button pButton class="h-2rem" [disabled]="isCreateDisabled()" [label]="getButtonLabel()" (click)="handleUpdateAndCreateOfResult()"></button>
    </div>
  </div>
</p-dialog>